<div class="container page-section-one">
    <div class="row align-items-center justify-content-center py-5">
        <div class="col-lg-6 col-md-8 col-10">
            <div class="row">
                <div class="col-12 text-center">
                    <p class="message-validation">RECIBIRÁ UN CÓDIGO DE VALIDACIÓN <br> EN EL TELÉFONO +34 *** *** {{ phone[6] }}{{ phone[7] }}{{ phone[8] }}</p>
                </div>
            </div>
           <div class="row">
               <div class="col-md-6 mb-md-0 mb-4">
                   <a (click)="navigateToDniCheck()" class="btn btn-primary d-block">CANCELAR</a>
               </div>
               <div class="col-md-6">
                   <a (click)="requestCode()" class="btn btn-primary d-block">CONTINUAR</a>
               </div>
           </div>
        </div>
    </div>
</div>

<app-modal [attr.id]="modalId" [modalId]="modalId" class="d-none">
    <div
        class="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-sm-10 offset-sm-1 col-12 offset-0 text-center message-container my-5">
        <p>{{textMessage}}</p>
    </div>
</app-modal>

<app-loader *ngIf="showLoader"></app-loader>

